module.exports = __webpack_public_path__ + "static/media/01f558cb.jpg";